export const RESERVATION_ID = 'reservationId';
export const DOCK_ID = 'dockId';
export const PROPERTY_NAME = 'propertyName';
export const USER_NAME = 'userName';
export const VEHICLE_NAME = 'vehicleName';
export const DOCK_NAME = 'dockName';
export const START_TIME = 'startTime';
export const DURATION_DATE_FORMAT = 'MM.dd.yyyy - t';

export const PAYMENT_TYPE_STRIPE = 'stripe';
export const PAYMENT_TYPE_CASH = 'cash';
export const PAYMENT_TYPE_FUEL_COMP = 'fuel_comp';
export const PAYMENT_TYPES = [
    PAYMENT_TYPE_STRIPE,
    PAYMENT_TYPE_CASH,
    PAYMENT_TYPE_FUEL_COMP,
];
